import { Component, Input, OnInit } from '@angular/core';
import { TaskState } from '../protogen/planning/service_pb';

@Component({
  selector: 'app-task-state-label',
  templateUrl: './task-state-label.component.html',
  styleUrls: ['./task-state-label.component.scss']
})
export class TaskStateLabelComponent implements OnInit {
  @Input() taskState: TaskState = TaskState.UNKNOWN_TASK_STATE;

  constructor() { }

  ngOnInit(): void { }

}
